import script from "./ActivityPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityPage.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityPage.vue?vue&type=style&index=0&id=270cfb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270cfb6c"]])

export default __exports__